import React from "react";
import Aux from "../AuxFunctions";
import "./SideBar.css"
import { withMyDataContext } from "../../context/DataProvider";
import PlusIcon from "mdi-react/PlusIcon"
import Colors from "../Colors";
import NotLoggedIn from "../ErrorPages/NotLoggedIn";
import TopHashtags from "../TopUsers/TopHashtags";
import { Link } from "react-router-dom";
import SettingsIcon from "mdi-react/SettingsIcon"

class Sidebar extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showMore: false,
      openModal: false,
    }
  }

  handleClick = () => {
    this.setState((prevState) => ({ showMore: !prevState.showMore }));
  }
  
  goToAddCoins = () => {
    try{
        this.props.history.push("/account/balance")
    }catch(error){
      Aux.handleError(error)
    }
  }

  goToSettings= () => {
    try{
        this.props.history.push("/settings")
    }catch(error){
      Aux.handleError(error)
    }
  }

  goToContact= () => {
    try{
        this.props.history.push("/contact")
    }catch(error){
      Aux.handleError(error)
    }
  }

  handleNotLoggedin =()=> {
    this.setState({openModal:true})
  }

  balanceRender = () => {
    return (
      <div className="cat-menu full-shadow" style={{marginTop:20, marginLeft:10}}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span className="cat-title-text cat-item-menu">Balance</span>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
            <span className="cat-item-text" style={{marginRight:5}}>{this.props.myDataProvider.coins || 0}$</span>
            <PlusIcon className="button-hover" style={{ backgroundColor: Colors.mainColor, color: "white", borderRadius: 50, marginRight: 20 }} onClick={this.goToAddCoins}></PlusIcon>
          </div>
        </div>
      </div>
    )
  }

  settingsRender = () => {
    return (
      <div style={{marginBottom:20, marginLeft:20}}>
        <div style={{display: "flex", alignItems:"center"}}>
          <span className="text-hover" style={{color:"#ccc"}} onClick={this.goToSettings}>Settings</span>
          <div style={{ height: 5, width: 5, borderRadius: "50%", backgroundColor: Colors.softText, margin: "0 10px" }}></div>
          <span className="text-hover" style={{color:"#ccc"}} onClick={this.goToContact}>Contact Us</span>
        </div>
      </div>
    )
  }

  ProfileRender = () => {
    return (
      <div className="cat-menu full-shadow" style={{marginTop:20, marginLeft:10,}}>
        <div style={{display:"flex", justifyContent:"space-between", alignItems:"center"}}>
        <Link  style={{display:"flex", alignItems:"center", padding:"15px 5px 15px 20px", overflow:"hidden", textDecoration:"none", flex:1}} to={"/account/profile"}>
            {Aux.showAvatar(30, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "Unknown")}
            <span className="side-bar-title-text" style={{textOverflow:"ellipsis", overflow:"hidden", margin:0, marginLeft:10, }}>{this.props.myDataProvider.user.username}</span>
        </Link>
        <SettingsIcon className="button-hover" style={{marginRight:15, color:Colors.softText}} onClick={this.goToSettings}></SettingsIcon>
        </div>
        <div className="cat-underline"></div>
        <div style={{display:"flex", flexDirection:"column", margin:"0px", paddingBottom:10}}>
          <div className="cat-single-item-menu" style={{textDecoration:"none", display:"flex", justifyContent:"space-between", alignItems:"center", color:Colors.darkText, fontWeight: 500, padding:"10px 30px", paddingRight:15}}>
            <span>Balance</span>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>
              <span style={{marginRight:5, fontWeight:"bold"}}>{this.props.myDataProvider.coins || 0}$</span>
              <PlusIcon className="button-hover" style={{ backgroundColor: Colors.mainColor, color: "white", borderRadius: 50, }} 
              onClick={this.goToAddCoins}></PlusIcon>
            </div>
          </div>
          <Link className="cat-single-item-menu" style={{textDecoration:"none", display:"flex", justifyContent:"flex-start", alignItems:"center",  color:Colors.darkText , fontWeight: 500, padding:"10px 30px"}} to={"/account/achievements"}>
            <span>{"Earn & Achievements"}</span>
            {this.props.myDataProvider.hasNewAchievement ?
              <div style={{ height: 7, width: 7, borderRadius: "50%", backgroundColor: Colors.red, marginLeft:10 }}></div> 
            : null}
          </Link>
          <Link className="cat-single-item-menu" style={{textDecoration:"none", display:"flex", justifyContent:"flex-start", alignItems:"center",  color:Colors.darkText, fontWeight: 500, padding:"10px 30px"}} to={"/account/daily"}>
            <span>Daily Rewards</span>
            {this.props.myDataProvider.hasNewDailyReward ?
              <div style={{ height: 7, width: 7, borderRadius: "50%", backgroundColor: Colors.red, marginLeft:10 }}></div> 
            : null}
          </Link>
          <Link className="cat-single-item-menu" style={{textDecoration:"none",  color:Colors.darkText , fontWeight: 500, padding:"10px 30px"}} to={"/account/invitefriends"}>
            <span>Invite friends</span>
          </Link>
          {this.props.myDataProvider.user?.role === "admin" || this.props.myDataProvider.user?.role === "dummy" ?
          <Link className="cat-single-item-menu" style={{textDecoration:"none",  color:Colors.darkText , fontWeight: 500, padding:"10px 30px"}} to={"/admin"}>
            <span>Admin</span>
          </Link>
         : null}
          {/* <Link className="cat-single-item-menu" style={{textDecoration:"none",  color:Colors.darkText }} to={"/settings"}>
            <span>Settings</span>
          </Link> */}
        </div>
      </div>
    )
  }

  toggleModal = () => {
    this.setState({
      openModal: !this.state.openModal
    });
  }

  goToCoins = () => {
    try{
        this.props.history.push("/account/balance")
    }catch(error){
        Aux.handleError(error)
    }
  }


  render() {
    return (
      <div className="cat-container ">
        {/* <CongratulationsModal active={this.state.openModal} onClose={this.toggleModal} coins={20000}></CongratulationsModal> */}
        <NotLoggedIn active={this.state.openModal} onClose={this.toggleModal}></NotLoggedIn>
        {/* {this.props.myDataProvider.user ? <this.balanceRender className="cat-balance"></this.balanceRender> : null} */}
        {this.props.myDataProvider.user ? <this.ProfileRender></this.ProfileRender> : null}
        <TopHashtags></TopHashtags>
        <this.settingsRender/>
        {/* <this.categoryRender></this.categoryRender> */}
      </div>
    );
  };
}
export default withMyDataContext(Sidebar);